import { render } from "./meusDadosPedidos.vue?vue&type=template&id=3e00b446&scoped=true"
import script from "./meusDadosPedidos.vue?vue&type=script&lang=js"
export * from "./meusDadosPedidos.vue?vue&type=script&lang=js"

import "./meusDadosPedidos.vue?vue&type=style&index=0&id=3e00b446&lang=scss&scoped=true"

import exportComponent from "C:\\Projetos_Somasys\\Delivery\\DeliverySoma-SOLO.2023.10.27\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e00b446"]])

export default __exports__